export const CAREER_POPUP_DATA = "CAREER_POPUP_DATA";
export const CAREER_POPUP_DATA_SUCCESS = "CAREER_POPUP_DATA_SUCCESS";
export const CAREER_POPUP_DATA_FAIL = "CAREER_POPUP_DATA_FAIL";

//update data
export const UPDATE_CAREER_POPUP_DATA = "UPDATE_CAREER_POPUP_DATA";
export const UPDATE_CAREER_POPUP_DATA_SUCCESS = "UPDATE_CAREER_POPUP_DATA_SUCCESS";
export const UPDATE_CAREER_POPUP_DATA_FAIL= "UPDATE_CAREER_POPUP_DATA_FAIL";

//get aiMarkup data
export const GET_CAREER_POPUP_DATA = "GET_CAREER_POPUP_DATA";
export const GET_CAREER_POPUP_DATA_SUCCESS = "GET_CAREER_POPUP_DATA_SUCCESS";
export const GET_CAREER_POPUP_DATA_FAIL = "GET_CAREER_POPUP_DATA_FAIL";
//hide Pop up data
export const HIDE_CAREER_POPUP_DATA = "HIDE_CAREER_POPUP_DATA";

//update career page integration link
export const UPDATE_CAREER_PAGE_INTEGRATION_LINK = "UPDATE_CAREER_PAGE_INTEGRATION_LINK";
export const UPDATE_CAREER_PAGE_INTEGRATION_LINK_SUCCESS = "UPDATE_CAREER_PAGE_INTEGRATION_LINK_SUCCESS";
export const UPDATE_CAREER_PAGE_INTEGRATION_LINK_FAIL= "UPDATE_CAREER_PAGE_INTEGRATION_LINK_FAIL";